import { useFavoriteProductsStore } from '../../entites/favorite/use-favorite-products.store.ts';
import { useUser } from '../../entites/authorization/use-user.ts';
import { ProductCardProps } from '@ui/product/product-card.tsx';
import { useCartProductsStore } from '../../entites/cart/use-cart-products.store.ts';
import { useNavigate } from 'react-router-dom';

export function useFavoriteProductsList() {
  const { isUseCache } = useUser();
  const navigate = useNavigate();
  const cartStore = useCartProductsStore({ isUseCache });
  const favoriteProducts = useFavoriteProductsStore({ isUseCache });

  const mapped = favoriteProducts.data.map<ProductCardProps | undefined>(
    (product) => {
      const mappedProduct: ProductCardProps = {
        image: product.main_photo || undefined,
        title: product.name,
        isShowPrice: true,
        isFavoriteShow: true,
        isFavoriteSelected: true,
        isSelected: cartStore.isProductInCart(product.id),
        description: product.category_name || '',
        onPress: () => navigate(`/products/${product.id}`),
        onPressAction: () => cartStore.insertProduct(product),
        onPressFavorite: () => favoriteProducts.invertProduct(product),
      };
      return mappedProduct;
    }
  );

  const array = Array(10)
    .fill(undefined)
    .map(() => ({
      isLoading: true,
    }));

  return {
    data: mapped || array,
    onLoadMore: favoriteProducts.onLoadMore,
    isLoading: favoriteProducts.isLoading,
    hasNextPage: favoriteProducts.hasNextPage,
  };
}
